export function truncateString(str, num) {
  if ((str === null || str === void 0 ? void 0 : str.length) > num) {
    return str.slice(0, num) + '...';
  } else {
    return str;
  }
}